var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgZoomPlus = function SvgZoomPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "plus icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pdp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PRIMAlighting-PDP-update1",
    transform: "translate(-1648.000000, -974.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-icon",
    transform: "translate(1648.000000, 974.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    stroke: "#201D41",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 13,
    cy: 13,
    r: 12.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(9.000000, 9.000000)",
    fill: "#201D41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 3,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(4.000000, 4.000000) rotate(-90.000000) translate(-4.000000, -4.000000) ",
    x: 0,
    y: 3,
    width: 8,
    height: 2
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZoomPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoomPlus.a11eed25.svg";
export { ForwardRef as ReactComponent };